import {momentRange} from "../../../../../gd/convert/moment-range";
import formatDaterange from "../../../../../gd/format/daterange";

export default class ReportUsersCollaborations_Settings {

    public daterange       : DateRange
    public userId          : ID

    constructor(data: any) {
        this.daterange     = data?.daterange ? momentRange(data.daterange.start, data.daterange.end) : momentRange(moment().subtract(1, "months"), moment())
        this.userId        = _.get(data, "userId", null)
    }

    get reportTitle() {
        return formatDaterange(this.daterange)
    }

    toJSON(): JSONObject {
        const result : JSONObject =  {
            userId      : this.userId,
        }

        if (this.daterange) {
            result['daterange'] = {
                start   : this.daterange.start.format("YYYY-MM-DD"),
                end     : this.daterange.end.format("YYYY-MM-DD")
            }
        }

        return result
    }
}
